/* ACH-only WildJar bootstrap. Explicitly enabled on the approved unpublished draft.
 * This gates initial loading, not a vendor shutdown API. Consent withdrawal
 * after loading still requires provider validation before production release.
 */
(() => {
  'use strict';

  const hosts = ['aussiecarhoists.com.au', 'www.aussiecarhoists.com.au', 'aussie-car-hoists.myshopify.com'];
  if (!hosts.includes(window.location.hostname) || window.Shopify?.designMode) return;
  if (window.__achWildjarBootstrap) return;
  window.__achWildjarBootstrap = true;

  const source = 'https://trkcall.com/scripts/94108.js';
  let requested = false;
  let privacyRequested = false;

  function existingVendorScript() {
    return Array.from(document.scripts).some(script => {
      try {
        const url = new URL(script.src, window.location.href);
        return url.hostname === 'trkcall.com' && url.pathname.startsWith('/scripts/');
      } catch {
        return false;
      }
    });
  }

  function loadIfAllowed() {
    if (requested || window.Shopify?.designMode || existingVendorScript()) return;
    const privacy = window.Shopify?.customerPrivacy;
    try {
      if (privacy?.analyticsProcessingAllowed() !== true || privacy?.marketingAllowed() !== true) return;
    } catch {
      // Missing, incomplete or failed privacy API: keep the usable base number.
      return;
    }

    requested = true;
    const script = document.createElement('script');
    script.id = 'ach-wildjar-tracking';
    script.async = true;
    script.src = source;
    script.addEventListener('error', () => {
      // Do not retry on every consent event or replace the number ourselves.
      console.warn('ACH WildJar script did not load; base phone number retained.');
    }, { once: true });
    document.head.appendChild(script);
  }

  function initialize() {
    if (window.Shopify?.customerPrivacy) {
      loadIfAllowed();
      return;
    }
    if (privacyRequested || typeof window.Shopify?.loadFeatures !== 'function') return;
    privacyRequested = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        if (!error) loadIfAllowed();
      });
    } catch {
      // Fail closed. No cookie reads, consent writes, or external fallback loader.
    }
  }

  // Re-read Shopify's permission methods; never trust event.detail as consent.
  document.addEventListener('visitorConsentCollected', initialize);
  window.addEventListener('load', initialize, { once: true });
  initialize();
})();
